import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_UNIT_MEASURES = '[UNIT MEASURES] GET UNIT MEASURES'
export const UPDATE_UNIT_MEASURE_STATUS = '[UNIT MEASURES] UPDATE UNIT MEASURE STATUS'

export function getUnitMeasures() {
  const request = api.get(`/unit-measures/all`)
  return (dispatch) => {
    dispatch({ type: GET_UNIT_MEASURES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_UNIT_MEASURES, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_UNIT_MEASURES, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener las unidades de medida")
      console.log(GET_UNIT_MEASURES, error)
    })
  }
}

export function updateUnitMeasureStatus(unitMeasureId) {
  const request = api.put(`/unit-measures/update-status/${unitMeasureId}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_UNIT_MEASURE_STATUS, payload: { updating_id: unitMeasureId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        dispatch({ type: UPDATE_UNIT_MEASURE_STATUS, payload: { updating_id: unitMeasureId } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_UNIT_MEASURE_STATUS, payload: { updating_id: unitMeasureId, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: UPDATE_UNIT_MEASURE_STATUS, payload: { updating_id: unitMeasureId } })
      toast.error("Error inesperado, no se pudo actualizar el estado de la unidad de medida")
      console.log(UPDATE_UNIT_MEASURE_STATUS, error)
    })
  }
}
